import { getCommonParamsItemLabel } from '@/utils/common'

export const contentTableConfig = {
  title: '',
  propList: [
    {
      prop: 'userName',
      label: 'user.user-name',
      width: 150
    },
    {
      prop: 'name',
      label: 'user.name',
      width: 200
    },
    {
      prop: 'tenantName',
      label: 'file.tenant',
      width: 150
    },
    {
      prop: 'email',
      label: 'user.email',
      width: 200
    },
    {
      prop: 'mobile',
      label: 'user.phone',
      width: 150
    },
    {
      prop: 'status',
      label: 'general.status',
      width: 100,
      formatter: (row) => {
        return getCommonParamsItemLabel(row, 'status')
      }
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      label: 'common.app-creation-time',
      width: 160
    },
    {
      label: 'common.app-operation',
      width: 380,
      slotName: 'handler'
    }
  ],
  showIndexColumn: true,
  showColSetting: true,
  tableColCheckedListName: 'userTableCheckedCol',
  tableColAllListName: 'userTableAllCol'
}
